import { UiComponents } from "@simulanisindia/ui";

const { SimInputBar } = UiComponents;

const RoleInformation = ({
  onlyView = false,
  errors = {},
  heading,
  name,
  setName,
  description,
  setDescription,
  isMobileView,
}) => {
  return (
    <>
      <div className="create-role">
        <h5> {heading} </h5>
        <p className="sub-heading">Here you can create role and set permissions to them</p>
        <div className="colorborder">
          <div className="row">
            <div className="col-md-4">
              <label>Name of the Role </label>
              <SimInputBar
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter role"
                disabled={onlyView}
              />
              <p className="inputError"> {errors?.name} </p>
            </div>
            <div className="col-md-8">
              <label>Description </label>
              <SimInputBar
                disabled={onlyView}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Enter role description"
              />
            </div>

            {/* these both button are exist in diff com for desktop  */}
            {/* {isMobileView && (
              <div className="col-md-12 pt-4">
                <div className="d-flex gap-2">
                  <button className="cancel">Cancel</button>
                  <button className="create">Submit</button>
                </div>
              </div>
            )} */}
          </div>
        </div>
      </div>
    </>
  );
};

export default RoleInformation;
